import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Button from './Button';
import Checkbox from './Checkbox';

const CheckboxDropdown = ({ options = [], selectedValues = [], onChange, title, right = false }) => {
	const [isOpen, setOpen] = useState(false);

	const handleToggle = () => {
		setOpen(!isOpen);
	};

	const handleCheckboxToggle = ({ target }) => {
		if (target.checked) {
			onChange([...selectedValues, target.value]);
		} else {
			onChange(selectedValues.filter((value) => value != target.value));
		}
	};

	return (
		<div className={cn('dropdown', 'checkbox-dropdown', { 'open': isOpen })}>
			<Button
				title={`${title} (${selectedValues.length})`}
				onClick={handleToggle}
				toggle
			/>
			<div className={cn('dropdown-menu', { 'dropdown-menu-right': right })}>
				{options.map((option) => (
					<Checkbox
						key={`${option.value}`}
						onChange={handleCheckboxToggle}
						checked={selectedValues.includes(option.value)}
						label={option.label}
						value={option.value}
					/>
				))}
			</div>
		</div>
	);
};

CheckboxDropdown.propTypes = {
	options: PropTypes.array,
	selectedValues: PropTypes.array,
	onChange: PropTypes.func,
	title: PropTypes.string,
	right: PropTypes.bool,
};

export default CheckboxDropdown;
